<template>
  <div id="notice">
    <div class="notice">
      <div id="scrollHeader" class="commonPageHeader">
        <img class="commonPageHeader-bgImg" src="~@/assets/images/notice/img_003.png"/>
        <div class="commonPageHeader-title">{{languageType==1?'动态通告': ''}}{{languageType==2?'News & Updates': ''}}{{languageType==3?'공지사항': ''}}</div>
      </div>
      <div class="notice-body">
        <div v-if="languageType==1" class="body-data"><span>共20条</span><span>第1页</span></div>
        <div v-else-if="languageType==2" class="body-data"><span>A total of 20 items</span><span>Page 1</span></div>
        <div v-else-if="languageType==3" class="body-data"><span>모두20조</span><span>1페이지</span></div>
        <div class="body-tableBox">
          <div class="tableBox-header clearBox">
            <div class="header-item span8" :class="{'englishFont': languageType==2}">{{languageType==1?'序号': ''}}{{languageType==2?'Number': ''}}{{languageType==3?'번호': ''}}</div>
            <div class="header-item span60">{{languageType==1?'标题': ''}}{{languageType==2?'Title': ''}}{{languageType==3?'제목': ''}}</div>
            <div class="header-item span20">{{languageType==1?'内容分类': ''}}{{languageType==2?'Content classification': ''}}{{languageType==3?'내용 분류': ''}}</div>
            <div class="header-item span12">{{languageType==1?'日期': ''}}{{languageType==2?'Date': ''}}{{languageType==3?'날짜': ''}}</div>
          </div>
          <div class="tableBox-content">
            <template v-for="(item, index) in noticeList">
              <div class="tableBox-content-li clearBox" :key="index" @click="toNoticeDetail(item)">
                <div class="li-item span8">{{index+1}}</div>
                <div class="li-item span60">{{languageType==1?item.title: ''}}{{languageType==2?item.titleExt1: ''}}{{languageType==3?item.titleExt2: ''}}</div>
                <div class="li-item span20">{{languageType==1?item.type: ''}}{{languageType==2?item.typeExt1: ''}}{{languageType==3?item.typeExt2: ''}}</div>
                <div class="li-item span12">{{item.createTime.split(" ")[0]}}</div>
              </div>
            </template>
          </div>
        </div>
        <commonPagination
          :total="total"
          :pageSize="pageSize"
          @page-change="toChangePage"
        />
      </div>
    </div>

    <div class="noticeScreen">
      <div class="commonScreenPageHeader">
        <img class="commonScreenPageHeader-bgImg" src="~@/assets/images/notice/img_003.png"/>
        <div class="commonScreenPageHeader-title">{{languageType==1?'动态通告': ''}}{{languageType==2?'News & Updates': ''}}{{languageType==3?'공지사항': ''}}</div>
      </div>
      <div class="noticeScreen-body">
        <div class="body-content">
          <template v-for="(item, index) in noticeList">
            <div class="content-li clearBox" :key="index" @click="toNoticeDetail(item)">
              <div class="content-li-lp">{{index+1}}</div>
              <div class="content-li-rp">
                <div class="rp-title">{{languageType==1?item.title: ''}}{{languageType==2?item.titleExt1: ''}}{{languageType==3?item.titleExt2: ''}}</div>
                <div class="rp-tip">{{languageType==1?item.type: ''}}{{languageType==2?item.typeExt1: ''}}{{languageType==3?item.typeExt2: ''}}</div>
                <div class="rp-time">{{item.createTime.split(" ")[0]}}</div>
              </div>
            </div>
          </template>
        </div>
        <commonPagination
          :isCenter="true"
          :total="total"
          :pageSize="pageSize"
          @page-change="toChangePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getNoticePage} from "@/api/notice";
import commonPagination from "@/components/commonPagination";
export default {
  name: 'notice',
  components: {
    commonPagination
  },
  data(){
    return {
      noticeList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }
  },
  computed: {
    ...mapGetters(["languageType"]),
  },
  mounted() {
    this.toGetNoticeData()
  },
  methods: {
    // 获取公告列表
    toGetNoticeData(){
      getNoticePage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then(res=>{
        if(res.code==200){
          this.noticeList=res.rows
          this.total=res.total
        }
      })
    },
    // 页码改变
    toChangePage(page){
      this.pageNum=page
      this.toGetNoticeData()
    },
    // 跳转信息
    toNoticeDetail(row){
      this.$router.push({
        path: '/noticeDetail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" scoped lang="scss">
@import "./index.scss";
</style>
